export interface ServiceRoutePrefix {
  /** PlatformService.slug. */
  serviceSlug: string;
  /** URL prefixes owned by the service. */
  prefixes: string[];
}

export const SERVICE_ROUTE_PREFIXES: ServiceRoutePrefix[] = [
  { serviceSlug: 'health-records', prefixes: ['/health-records'] },
  { serviceSlug: 'health-assessment', prefixes: ['/health-assessment'] },
  { serviceSlug: 'health-insights', prefixes: ['/health-summary'] },
  { serviceSlug: 'ai-family-doctor', prefixes: ['/ai-family-doctor'] },
  { serviceSlug: 'smart-reports', prefixes: ['/smart-reports'] },
  { serviceSlug: 'symptoms-tracker', prefixes: ['/symptoms-checker'] },
  { serviceSlug: 'medicine-reminder', prefixes: ['/my-reminders'] },
  { serviceSlug: 'insurance-management', prefixes: ['/insurance-record', '/insurance-records'] },
  { serviceSlug: 'group-mediclaim', prefixes: ['/my-mediclaim'] },
  { serviceSlug: 'wearable-devices', prefixes: ['/wearable-devices'] },
  { serviceSlug: 'gym-services', prefixes: ['/gymservices'] },
  { serviceSlug: 'discount-vouchers', prefixes: ['/offers', '/discount-vouchers', '/discounts'] },
  { serviceSlug: 'tele-consultation', prefixes: ['/teleconsultation'] },
  { serviceSlug: 'sponsored-packages', prefixes: ['/sponsored-packages'] },
  { serviceSlug: 'women-health', prefixes: ['/womens-health'] },
  { serviceSlug: 'child-development', prefixes: ['/child-development'] },
  { serviceSlug: 'elderly-care', prefixes: ['/elderly-care'] },
  { serviceSlug: 'mental-wellness', prefixes: ['/mental-wellness'] },
  { serviceSlug: 'disease-prediction', prefixes: ['/disease-prediction'] },
];

export function serviceSlugForPath(pathname: string): string | undefined {
  let match: { slug: string; length: number } | undefined;

  SERVICE_ROUTE_PREFIXES.forEach(({ serviceSlug, prefixes }) => {
    prefixes.forEach((prefix) => {
      const owned = pathname === prefix || pathname.startsWith(`${prefix}/`);
      if (owned && (!match || prefix.length > match.length)) {
        match = { slug: serviceSlug, length: prefix.length };
      }
    });
  });

  return match?.slug;
}